import { useEffect } from 'react';

/**
 * Loads the GA4 gtag.js script.
 * SPA-compatible replacement for the Next.js Script-based component.
 */
export function GAnalyticsScript({ measurementId }: { measurementId: string }) {
  useEffect(() => {
    if (!measurementId) return;

    // Avoid double-init
    if ((window as any).gtag) return;

    (window as any).dataLayer = (window as any).dataLayer || [];
    // Must use `arguments` (not rest params) — gtag.js identifies queued
    // commands by the Arguments object type; plain arrays are silently ignored.
    // eslint-disable-next-line prefer-rest-params
    const gtag: (...args: any[]) => void = function () {
      (window as any).dataLayer.push(arguments);
    } as any;
    (window as any).gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId, { send_page_view: false });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [measurementId]);

  return null;
}
